import Navigator from 'app';
const LegislativeDayCollection = Backbone.Collection.extend({
  model: Backbone.Model.extend(),
  url: Navigator.config.api_base + 'days/'
});
const API = {
  getLegislativeDays: function getLegislativeDays() {
    var d = $.Deferred();
    if (!Navigator.days || Navigator.days.length === 0) {
      Navigator.days = new LegislativeDayCollection();
      Navigator.days.fetch({
        dataType: "json",
        success: function (data) {
          d.resolve(data);
        }
      });
      return d.promise();
    } else {
      return Navigator.days;
    }
  }
};
Navigator.reqres.setHandler("days", function () {
  return API.getLegislativeDays();
});
export { LegislativeDayCollection as default };